import styles from "./OtherUsefulApp.module.css";

const OtherUsefulAppCard = ({ name, description, children, appLink }) => {
      return (
            <div className={styles.usefulAppCardWrapper}>
                  <div className={styles.iconWrapper}>{children}</div>
                  <div>
                        <div>
                              <h4 className={styles.appName}>{name}</h4>
                              <p className={styles.appDescription}>
                                    {description}
                              </p>
                        </div>

                        <a target='_blank' href={appLink}>
                              <button className={styles.appLinkButton}>
                                    {appLink?'OPEN APPLICATION':'COMING SOON'}
                              </button>
                        </a>
                  </div>
            </div>
      );
};

export default OtherUsefulAppCard;
